import {MathFunctions} from "./mathHelper";
import {DrawingCanvasFormSide} from "../drawingCanvasFormSide";
import {ApplicationState, EDIT_MODES} from "./applicationState";

export class CursorService {
    canvas: HTMLCanvasElement;

    constructor(canvas: HTMLCanvasElement) {
        this.canvas = canvas;
    }

    setPathCursor(pathCursor: string) {
        if (pathCursor === 'move') {
            DrawingCanvasFormSide.dc_changeMouseCursor(this.canvas,'move');
        } else if (pathCursor === 'menu') {
            DrawingCanvasFormSide.dc_changeMouseCursor(this.canvas,'pointer');
        } else if (pathCursor === 'click') {
            DrawingCanvasFormSide.dc_changeMouseCursor(this.canvas,'crosshair');
        } else
            DrawingCanvasFormSide.dc_changeMouseCursor(this.canvas,'default');
    }

    setSegmentCursor(segmentCursor: string, segment: paper.Segment | null = null) {
        if (segmentCursor === 'drag' && segment != null) {
            this.setSegmentDragCursor(segment);
        } else if (segmentCursor === 'menu') {
            DrawingCanvasFormSide.dc_changeMouseCursor(this.canvas,'pointer');
        } else
            DrawingCanvasFormSide.dc_changeMouseCursor(this.canvas,'default');
    }

    setSegmentDragCursor(segment: paper.Segment) {
        var inLine = MathFunctions.getVectorBetweenPoints(segment.previous.point, segment.point);
        var outLine = MathFunctions.getVectorBetweenPoints(segment.point, segment.next.point);
        var arrowDir = MathFunctions.addVectors(MathFunctions.reverseVector(inLine), outLine);
        if (MathFunctions.isOppositeSign(arrowDir.x, arrowDir.y)) {
            DrawingCanvasFormSide.dc_changeMouseCursor(this.canvas,'ne-resize');
        } else {
            DrawingCanvasFormSide.dc_changeMouseCursor(this.canvas,'nw-resize');
        }
    }

    setLineDragCursor(curve: any) {
        if (MathFunctions.isHorizontalLine(curve, true)) {
            DrawingCanvasFormSide.dc_changeMouseCursor(this.canvas,'n-resize');
        } else {
            DrawingCanvasFormSide.dc_changeMouseCursor(this.canvas,'w-resize');
        }
    }

    setLineCursor(curveCursor: string, curve: any) {
        if (ApplicationState.CURRENTMODE === EDIT_MODES.BUMPS_RADIUSES && curve.segment1.data.bumpGroupData) {
            //if(!measurementVisible.suppressAltCursors)
            this.setLineDragCursor(curve);
        } else {
            if (curveCursor === 'drag') {
                this.setLineDragCursor(curve);
            } else if (curveCursor === 'menu') {
                DrawingCanvasFormSide.dc_changeMouseCursor(this.canvas,'pointer');
            } else
                DrawingCanvasFormSide.dc_changeMouseCursor(this.canvas,'default');
        }

    }

    setCookTopSplashCursor(cookTopSplashCursor: string, cookTopSplash: any) {
        if (cookTopSplashCursor === "move") {
            DrawingCanvasFormSide.dc_changeMouseCursor(this.canvas,"move");
        } else if (cookTopSplashCursor === "menu") {
            DrawingCanvasFormSide.dc_changeMouseCursor(this.canvas,"pointer");
        } else
            DrawingCanvasFormSide.dc_changeMouseCursor(this.canvas,"default");
    }

    setCutoutCursor(cutoutCursor: string, sink: any) {
        if (cutoutCursor === 'move') {
            DrawingCanvasFormSide.dc_changeMouseCursor(this.canvas,'move');
        } else if (cutoutCursor === 'menu') {
            DrawingCanvasFormSide.dc_changeMouseCursor(this.canvas,'pointer');
        } else
            DrawingCanvasFormSide.dc_changeMouseCursor(this.canvas,'default');
    }

    setSinkCursor(sinkCursor: string, sink: any) {
        if (sinkCursor === 'move') {
            DrawingCanvasFormSide.dc_changeMouseCursor(this.canvas,'move');
        } else if (sinkCursor === 'menu') {
            DrawingCanvasFormSide.dc_changeMouseCursor(this.canvas,'pointer');
        } else
            DrawingCanvasFormSide.dc_changeMouseCursor(this.canvas,'default');
    }

    setPointTextCursor(allowAlteringMeasurements: boolean, pt: any) {
        if (pt.data && pt.data.isAngle) {
            if (allowAlteringMeasurements)
                DrawingCanvasFormSide.dc_changeMouseCursor(this.canvas,'pointer');
            else
                DrawingCanvasFormSide.dc_changeMouseCursor(this.canvas,'default');
        } else if (allowAlteringMeasurements)
            DrawingCanvasFormSide.dc_changeMouseCursor(this.canvas,'text');
        else
            DrawingCanvasFormSide.dc_changeMouseCursor(this.canvas,'default');
    }
}
